import React from 'react';
import { cn } from '@shared/lib/utils';
import paygatexSidebarLogo from '@shared/assets/paygatex-sidebar.png';
import smallPaygatexLogo from '@shared/assets/small-paygatex.png';

interface SidebarHeaderProps {
  className?: string;
  children?: React.ReactNode;
  collapsed?: boolean;
}

export function SidebarHeader({ className, children, collapsed }: SidebarHeaderProps): React.ReactElement {
  return (
    <header
      className={cn(
        'flex shrink-0 flex-col gap-2 pb-14',
        'ps-[var(--layout-sidebar-padding-inline-start,32px)] pe-[var(--layout-sidebar-padding-inline-end,24px)]',
        'transition-[padding,min-height] duration-normal ease-standard',
        collapsed ? 'min-h-0 items-center px-3 pt-6 pb-8' : 'min-h-[140px] pt-11',
        className
      )}
      data-name="SidebarHeader"
    >
      <div
        className={cn(
          'relative flex h-7 w-full items-center',
          !collapsed && 'translate-y-0.5',
          collapsed && 'justify-center'
        )}
        data-name="logo-wrapper"
      >
        {children || (
          <>
            <img
              src={paygatexSidebarLogo}
              alt="Paygatex"
              className={cn(
                'h-7 w-[196px] shrink-0 transition-[opacity,transform] duration-normal ease-standard',
                collapsed
                  ? 'pointer-events-none absolute opacity-0 -translate-x-1'
                  : 'opacity-100 translate-x-0'
              )}
            />
            <img
              src={smallPaygatexLogo}
              alt=""
              aria-hidden
              className={cn(
                'h-[29px] w-12 shrink-0 transition-[opacity,transform] duration-normal ease-standard',
                collapsed
                  ? 'opacity-100 translate-x-0'
                  : 'pointer-events-none absolute opacity-0 translate-x-1'
              )}
            />
          </>
        )}
      </div>
    </header>
  );
}
